"use client";

import { ReactNode, useMemo } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import FormProvider from "@/libs/shared/providers/FormProvider";

type ProcessorFlagsModalProviderProps = {
  children: ReactNode;
};

const ProcessorFlagsModalProvider = ({
  children,
}: ProcessorFlagsModalProviderProps) => {
  const { t } = useTranslation();

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        data_processor: yup.boolean(),
      }),
    [t],
  );

  const options = useMemo(
    () => ({
      resolver: yupResolver(validationSchema) as any,
      mode: "onChange" as const,
      defaultValues: {
        data_processor: true,
      },
    }),
    [validationSchema],
  );

  return <FormProvider {...options}>{children}</FormProvider>;
};

export default ProcessorFlagsModalProvider;
